 

import { Dependency } from '../models/DynamicFieldData'

const evaluateOperator = (fieldValue:  string | number, operator: string, value: string | number): boolean => {
  switch (operator) {
    case '!=':
      return fieldValue != value
    case '>':
      return fieldValue > value
    case '<':
      return fieldValue < value
    case '>=':
      return fieldValue >= value
    case '<=':
      return fieldValue <= value
    case '==':
    default:
      return fieldValue == value
  }
}

export const evaluateVisibilityCondition = (dependencies?: Dependency[], watchedValues?: string[], dependentFieldNames?: string[]): boolean => {
  if (!watchedValues || !dependencies || !dependentFieldNames) {
    return true
  }

  return dependencies.every(dep => {
    const watchIndex = dependentFieldNames.indexOf(dep.fieldName)
    const fieldValue = watchedValues[watchIndex]
    const condition = dep?.condition || 'and'
    const operator = dep.operator

    if (fieldValue === undefined) {
      return false
    }

    if (condition === 'or') {
      return dep.values.some(value => evaluateOperator(fieldValue, operator, value))
    } else {
      return dep.values.every(value => evaluateOperator(fieldValue, operator, value))
    }
  })
}
